import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { Address, Availability, Location } from "./classes";

export const ADDRESS_PROVIDER_SERVICE = new InjectionToken<IAddressProviderService>('ADDRESS_PROVIDER_SERVICE');

export interface IAddressProviderService {
    addressId$: Observable<number>;
    address$: Observable<Address>;
}

export const LOCATION_PROVIDER_SERVICE = new InjectionToken<ILocationProviderService>('LOCATION_PROVIDER_SERVICE');

export interface ILocationProviderService {
    locationId$: Observable<number>;
    location$: Observable<Location>;
}

export const AVAILABILITIES_PROVIDER_SERVICE = new InjectionToken<IAvailabilityProviderService>('AVAILABILITY_PROVIDER_SERVICE');

export interface IAvailabilityProviderService {
    availabilities$: Observable<Availability[]>;
}
